module.exports = __webpack_public_path__ + "static/media/logos3.b60bc7d3.png";